import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AxiosError } from 'axios'
import type { ProjectId } from 'common/types'

import { upsertVelocityModelApi } from '../../api'
import type { CreateVelocityModel } from '../../types'
import { velocitySimulationsSlice } from './velocitySimulationsSlice'

const EXTERNAL_ERROR = 'Произошла внешняя ошибка'

type LayersErrorType = { errors?: { Layers?: string[] } } | undefined
export const { clearVelocitySimulations } = velocitySimulationsSlice.actions

const throwVelocityModelError = (err: AxiosError<LayersErrorType>) => {
  const error = err.response?.data?.errors?.Layers?.[0]
  throw new Error(error ?? EXTERNAL_ERROR)
}

export const calculateVelocitySimulation = createAsyncThunk(
  'VelocitySimulations',
  async ({
    projectId,
    modelId,
    data,
  }: {
    projectId: ProjectId
    modelId?: string
    data: CreateVelocityModel
  }) => upsertVelocityModelApi(projectId, data, modelId).catch(throwVelocityModelError),
)
